import {TextButton} from "@FRAMEWORK/ui/mobile/button";
import {PopupContainer} from "@FRAMEWORK/ui/mobile/popup";
import {Checkbox, TextInput, Textarea} from "@FRAMEWORK/ui/mobile/input";
import {Select} from "@FRAMEWORK/ui/mobile/select";
import {useEffect, useState} from "react";
import BulletListItem from "@FRAMEWORK/ui/mobile/list/BulletListItem";
import * as style from "@COMPONENTS/style/common/mailshareM";
import RequiredText from "@FRAMEWORK/ui/mobile/text/RequiredText";
import RequiredCheck from "@FRAMEWORK/ui/mobile/text/RequiredCheck";
import {Area} from "@FRAMEWORK/ui/mobile/layout";
import {OverlayState} from "@/hooks/common/useOverlay";
import useCode from "@QUERIES/essential/code/useCode";
import {validation} from "@yb/utils";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import useEventDetail from "@QUERIES/prdt/event/useEventDetail";
import useGoodsDetail from "@QUERIES/prdt/goods/useGoodsDetail";
import {useRouter} from "next/router";

interface SendEmailProps extends OverlayState {
	/** 메일 타입
	 * @description detailPackage : P
	 * @description locallist : G
	 */
	dspGubun: "P" | "G";

	/** goodsCd
	 * @description "G 일때 필수"
	 */
	goodsCd?: string;

	/** evCd
	 * @description "P 일떄 필수"
	 */
	evCd?: string;

	/** menu
	 * @description "P,G 일떄 필수"
	 */
	menu?: string;

	/** dspSid
	 * @description "P,G 일떄 필수"
	 */
	dspSid?: string;
}

const MailShare = (props: SendEmailProps) => {
	const query = useRouter().query as {[x: string]: string};
	const {
		dspGubun,
		evCd = query.evCd || "",
		goodsCd = query.goodsCd || "",
		menu = query.menu || "",
		dspSid = query.dspSid || "",
		...overlay
	} = props;
	const [sameSender, setSameSander] = useState(false);
	const [collect, setCollect] = useState("N");
	const [senderDomain, setSenderDomain] = useState("");
	const [reciverDomain, setReciverDomain] = useState("");
	const [required, setRequired] = useState({
		sndrName: "",
		sndrEmail: "",
		rcptName: "",
		rcptEmail: "",
		collect: "",
		subject: "",
		message: "",
	});
	const [value, setValue] = useState({
		dspGubun,
		evCd,
		goodsCd,
		menu,
		dspSid,
		rcptEmail: "",
		rcptName: "",
		sndrEmail: "",
		sndrName: "",
		subject: "",
		message: "",
		collectInfoYn: "N",
	});

	/** 이메일 도메인 공통코드 */
	const code = useCode("WEB_CUST_MAIL", {placeholderData: {body: []}}).data.body;

	const evNm = useEventDetail(evCd, {enabled: dspGubun === "P"}).data.body.evNm;

	const goodsNm = useGoodsDetail(goodsCd, {enabled: dspGubun === "G"}).data.body.goodsNm;

	const input = (key: string) => e => {
		const text = e.target.value.substring(0, key === "subject" ? 60 : 250);
		if (["sndrEmailId", "sndrEmailDomain"].indexOf(key) > -1) {
			const [id, domain = ""] = value.sndrEmail.split("@");
			key === "sndrEmailId" && setValue({...value, sndrEmail: `${text}@${domain}`});
			key === "sndrEmailDomain" && setValue({...value, sndrEmail: `${id}@${text}`});
			setRequired({...required, sndrEmail: ""});
		} else if (["reciverEmailId", "reciverEmailDomain"].indexOf(key) > -1) {
			const [id, domain = ""] = value.rcptEmail.split("@");
			key === "reciverEmailId" && setValue({...value, rcptEmail: `${text}@${domain}`});
			key === "reciverEmailDomain" && setValue({...value, rcptEmail: `${id}@${text}`});
			setRequired({...required, rcptEmail: ""});
		} else {
			setValue({...value, [key]: text});
			setRequired({...required, [key]: ""});
		}
	};
	const onSameSenderChecked = e => setSameSander(!sameSender);
	const onCollectChecked = e => {
		setCollect(e.target.checked === true ? "Y" : "N");
		setValue({...value, collectInfoYn: e.target.checked === true ? "Y" : "N"});
		setRequired({...required, collect: ""});
	};

	const changeSenderDomain = e => {
		const [id] = value.sndrEmail.split("@");
		setValue({...value, sndrEmail: `${id}@${e.target.value.toLowerCase()}`});
		setSenderDomain(e.target.value);
		setRequired({...required, sndrEmail: ""});
	};
	const changeReciverDomain = e => {
		const [id] = value.rcptEmail.split("@");
		setValue({...value, rcptEmail: `${id}@${e.target.value.toLowerCase()}`});
		setReciverDomain(e.target.value);
		setRequired({...required, rcptEmail: ""});
	};

	const formValidation = () => {
		const {sndrName, sndrEmail, rcptName, rcptEmail, subject, message} = value;
		const [sndrId, sndrDomain] = sndrEmail.split("@");
		const [rcptId, rcptDomain] = rcptEmail.split("@");
		/** 보내는 사람  */
		if (sndrName.length === 0) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "이름을 입력하세요."});
			return false;
		}
		if (/\s/g.test(sndrName)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (sndrId.length === 0) {
			(document.querySelector("#sndrEmailId") as HTMLInputElement).focus();
			setRequired({...required, sndrEmail: "보내는 사람의 이메일 주소를 입력하세요."});
			return false;
		}
		if (/\s/g.test(sndrId)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (sndrDomain.length === 0) {
			(document.querySelector("#sndrEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, sndrEmail: "보내는 사람의 이메일 도메인을 입력하세요."});
			return false;
		}
		if (!validation.domain(sndrDomain)) {
			(document.querySelector("#sndrEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, sndrEmail: "보내는 사람의 이메일 도메인을 확인하세요."});
			return false;
		}

		/** 받는 사람 */
		if (rcptName.length === 0) {
			(document.querySelector("#rcptName") as HTMLInputElement).focus();
			setRequired({...required, rcptName: "이름을 입력하세요."});
			return false;
		}
		if (/\s/g.test(rcptName)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (rcptId.length === 0) {
			(document.querySelector("#reciverEmailId") as HTMLInputElement).focus();
			setRequired({...required, rcptEmail: "받는 사람의 이메일 주소를 입력하세요."});
			return false;
		}
		if (/\s/g.test(rcptId)) {
			(document.querySelector("#sndrName") as HTMLInputElement).focus();
			setRequired({...required, sndrName: "공백을 제거하세요."});
			return false;
		}
		if (rcptDomain.length === 0) {
			(document.querySelector("#reciverEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, rcptEmail: "받는 사람의 이메일 도메인을 입력하세요."});
			return false;
		}
		if (!validation.domain(rcptDomain)) {
			(document.querySelector("#reciverEmailDomain") as HTMLInputElement).focus();
			setRequired({...required, rcptEmail: "받는 사람의 이메일 도메인을 확인하세요."});
			return false;
		}

		/** 내용 */
		if (subject.length === 0) {
			(document.querySelector("#subject") as HTMLInputElement).focus();
			setRequired({...required, subject: "제목을 입력하세요."});
			return false;
		}
		if (message.length === 0) {
			(document.querySelector("#message") as HTMLInputElement).focus();
			setRequired({...required, message: "내용을 입력하세요."});
			return false;
		}

		/** 개인수집 이용 동의 */
		if (value.collectInfoYn === "N") {
			(document.querySelector("#check-agree") as HTMLInputElement).focus();
			setRequired({...required, collect: "개인정보 수집/이용에 동의하셔야합니다."});
			return false;
		}
		return true;
	};

	const sendEmail = async () => {
		try {
			if (formValidation()) {
				const result = await useConfigureAxios({
					method: "POST",
					url: `${publicRuntimeConfig.ENV_ESSENTIAL_API_BASEPATH}/api/mail/share`,
					data: {...value, subject: value.subject.trim(), message: value.message.trim()},
				});
				result.data.code === "0000" &&
					MessageUtil.alert("메일을 발송하였습니다.", () => {
						overlay.close();
					});
				if (result.data.code !== "0000") {
					throw new Error("");
				}
			}
		} catch (e) {
			MessageUtil.alert("메일을 발송에 실패하였습니다.");
		}
	};

	/** 보내는사람과 동일 */
	useEffect(() => {
		const {sndrName, sndrEmail} = value;
		const [id, domain] = sndrEmail.split("@");
		if (sameSender) {
			if (sndrName.length === 0) {
				setRequired({...required, sndrName: "이름을 입력하세요."});
				setSameSander(false);
				return;
			} else if (!id || !domain) {
				setRequired({...required, sndrEmail: "보내는 사람의 이메일 주소를 입력하세요."});
				setSameSander(false);
				return;
			} else if (!validation.domain(domain)) {
				setRequired({...required, sndrEmail: "이메일 도메인 형식이 잘못되었습니다."});
				setSameSander(false);
				return;
			}
			setValue({...value, rcptName: value.sndrName, rcptEmail: value.sndrEmail});
			setRequired({...required, sndrName: "", sndrEmail: ""});
			setReciverDomain(senderDomain);
		} else {
			setValue({...value, rcptName: "", rcptEmail: ""});
			setReciverDomain("");
		}
	}, [sameSender]);

	useEffect(() => {
		if (dspGubun === "P") setValue({...value, subject: evNm});
		if (dspGubun === "G") setValue({...value, subject: goodsNm});
	}, [evNm, goodsNm]);

	return (
		<PopupContainer {...overlay} title="이메일 공유" size="full" padding={false} animate="slideIn">
			<Area>
				<style.CotentBox>
					<style.Subject>
						고객님이 보셨던 상품을
						<br />
						<strong>이메일로 공유하실 수 있습니다.</strong>
					</style.Subject>
				</style.CotentBox>
			</Area>
			<Area>
				<style.CotentBox>
					<style.InfoText>
						<style.RequiredIcon title="필수입력 아이콘" />는 필수입력 항목입니다.
					</style.InfoText>
					<style.Table>
						<caption>이메일 공유를 위한 정보 입력 폼</caption>
						<tbody>
							<tr>
								<th scope="col">상품명</th>
							</tr>
							<tr>
								<td>
									{dspGubun === "P" && evNm}
									{dspGubun === "G" && goodsNm}
								</td>
							</tr>
							<tr>
								<th scope="col">
									<span>
										보내는 사람
										<RequiredCheck />
									</span>
								</th>
							</tr>
							<tr>
								<th scope="col">이름</th>
							</tr>
							<tr>
								<td>
									<style.InputRow wrong={!!required.sndrName}>
										<TextInput id="sndrName" onChange={input("sndrName")} value={value.sndrName} />
										{required.sndrName && <RequiredText>{required.sndrName}</RequiredText>}
									</style.InputRow>
								</td>
							</tr>
							<tr>
								<th scope="col">이메일</th>
							</tr>
							<tr>
								<td>
									<style.InputRow wrong={!!required.sndrEmail}>
										<style.MailWrap>
											<TextInput
												width="calc(50% - 15px)"
												onChange={input("sndrEmailId")}
												value={value.sndrEmail.split("@").at(0)}
												id="sndrEmailId"
											/>
											<span>@</span>
											<TextInput
												width="calc(50% - 15px)"
												readOnly={!!senderDomain}
												onChange={input("sndrEmailDomain")}
												value={value.sndrEmail.split("@")?.at(1) || ""}
												id="sndrEmailDomain"
											/>
											<Select onChange={changeSenderDomain} value={senderDomain}>
												<option value="">직접입력</option>
												{code.map(item => (
													<option key={item.commCdId} value={item.commCdId}>
														{item.commCdNm}
													</option>
												))}
											</Select>
										</style.MailWrap>
										{required.sndrEmail && <RequiredText>{required.sndrEmail}</RequiredText>}
									</style.InputRow>
								</td>
							</tr>
							<tr>
								<th scope="col">
									<style.CheckBoxWrap>
										<span>
											받는 사람
											<RequiredCheck />
										</span>
										<span>
											<label htmlFor="check-all">보내는사람과 동일</label>
											<Checkbox id="check-all" value="same" onChange={onSameSenderChecked} checked={sameSender} />
										</span>
									</style.CheckBoxWrap>
								</th>
								<tr>
									<th scope="col">이름</th>
								</tr>
								<tr>
									<td>
										<style.InputRow wrong={!!required.rcptName}>
											<TextInput id="rcptName" onChange={input("rcptName")} value={value.rcptName} />
											{required.rcptName && <RequiredText>{required.rcptName}</RequiredText>}
										</style.InputRow>
									</td>
								</tr>
								<tr>
									<th scope="col">이메일</th>
								</tr>
								<tr>
									<td>
										<style.InputRow wrong={!!required.rcptEmail}>
											<style.MailWrap>
												<TextInput
													width="calc(50% - 15px)"
													onChange={input("reciverEmailId")}
													value={value.rcptEmail.split("@").at(0)}
													id="reciverEmailId"
												/>
												<span>@</span>
												<TextInput
													width="calc(50% - 15px)"
													readOnly={!!reciverDomain}
													onChange={input("reciverEmailDomain")}
													value={value.rcptEmail.split("@")?.at(1) || ""}
													id="reciverEmailDomain"
												/>
												<Select onChange={changeReciverDomain} value={reciverDomain}>
													<option value="">직접입력</option>
													{code.map(item => (
														<option key={item.commCdId} value={item.commCdId}>
															{item.commCdNm}
														</option>
													))}
												</Select>
											</style.MailWrap>
											{required.rcptEmail && <RequiredText>{required.rcptEmail}</RequiredText>}
										</style.InputRow>
									</td>
								</tr>
								<tr>
									<th scope="col">
										<span>
											제목
											<style.ByteText>({value.subject.length}자/60자)</style.ByteText>
											<RequiredCheck />
										</span>
									</th>
								</tr>
								<tr>
									<td>
										<style.InputRow wrong={!!required.subject}>
											<TextInput id="subject" onChange={input("subject")} value={value.subject} />
											{required.subject && <RequiredText>{required.subject}</RequiredText>}
										</style.InputRow>
									</td>
								</tr>
								<tr>
									<th scope="col">
										<span>
											내용
											<style.ByteText>({value.message.length}자/250자)</style.ByteText>
											<RequiredCheck />
										</span>
									</th>
								</tr>
								<tr>
									<td>
										<style.InputRow wrong={!!required.message}>
											<Textarea id="message" height="180px" onChange={input("message")} value={value.message} />
											{required.message && <RequiredText>{required.message}</RequiredText>}
										</style.InputRow>
									</td>
								</tr>
							</tr>
						</tbody>
					</style.Table>
				</style.CotentBox>
			</Area>
			<style.CotentBox>
				<style.BulletList>
					<BulletListItem>이메일 발송 서비스 제공을 위해 아래와 같이 개인정보를 수집할 수 있습니다.</BulletListItem>
					<BulletListItem>단순 메일 보내기 기능으로써 기재 정보는 별도 보관되어지지 않습니다.</BulletListItem>
				</style.BulletList>
				<style.InfoBox>
					<ul>
						<style.ArticleListItem>
							<strong>수집항목</strong>
							<span>보내는 사람, 받는 사람의 이름 및 이메일 주소</span>
						</style.ArticleListItem>
						<style.ArticleListItem>
							<strong>수집목적</strong>
							<span>이용자의 상품 공유 메일 발송을 위함</span>
						</style.ArticleListItem>
						<style.ArticleListItem>
							<strong>보유기간</strong>
							<span>보유하지않음</span>
						</style.ArticleListItem>
					</ul>
				</style.InfoBox>
				<style.InputRow wrong={true}>
					<style.CheckWrap>
						<Checkbox id="check-agree" value="collectInfoYn" checked={collect === "Y"} onChange={onCollectChecked} />
						<label htmlFor="check-agree">이메일 발송 서비스를 위한 개인정보 수집 이용에 동의합니다.</label>
					</style.CheckWrap>
					{required.collect && <RequiredText>{required.collect}</RequiredText>}
				</style.InputRow>
				<style.BtnArea>
					<TextButton text="발송하기" width="full" types="confirm" onClick={sendEmail} />
				</style.BtnArea>
			</style.CotentBox>
		</PopupContainer>
	);
};

export default MailShare;
